import { render, staticRenderFns } from "./bulletinAdd.vue?vue&type=template&id=5e4b7603&scoped=true&"
import script from "./bulletinAdd.vue?vue&type=script&lang=js&"
export * from "./bulletinAdd.vue?vue&type=script&lang=js&"
import style0 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=0&id=5e4b7603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4b7603",
  null
  
)

export default component.exports